var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenmsg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_307_1379",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_307_1379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75049 15.75H20.2505V13.5H6.75049V15.75ZM6.75049 12.375H20.2505V10.125H6.75049V12.375ZM6.75049 9H20.2505V6.75H6.75049V9ZM24.7505 24.75L20.2505 20.25H4.50049C3.88174 20.25 3.35224 20.0299 2.91199 19.5896C2.47099 19.1486 2.25049 18.6188 2.25049 18V4.5C2.25049 3.88125 2.47099 3.35137 2.91199 2.91037C3.35224 2.47012 3.88174 2.25 4.50049 2.25H22.5005C23.1192 2.25 23.6491 2.47012 24.0901 2.91037C24.5304 3.35137 24.7505 3.88125 24.7505 4.5V24.75Z",
    fill: "#47C87A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenmsg);
export default __webpack_public_path__ + "static/media/greenmsg.6f5c6742b4c85f105ff4cc6b4552b273.svg";
export { ForwardRef as ReactComponent };